import { Component, computed, inject, input, InputSignal, Signal } from '@angular/core';
import { UISizeType } from '../../models/ui-size.model';
import { DisplayAnimations } from '../../directives/display-animations';
import { BlockTemplateType } from '../../models/block-template.model';
import { WebSocketService } from '../../services/websocket-service';
import { WSBroadcastDataMessage } from '../../models/WSMessages/WS-broadcast-data-message.model';

const DEFAULT_DATA: WSBroadcastDataMessage['data'] = {
  power: 0,
  cadence: 0,
  speed: 0,
  heartRate: 0,
  distance: 0,
  time: 0,
  calories: 0,
  avgSpeed: 0,
  avgCadence: 0,
  avgPower: 0,
  avgHeartRate: 0,
  heartRateZone: 0,
  slope: 0,
  positiveSlope: 0,
  coachingResistance: 0,
  coordinates: [0, 0],
};

@Component({
  selector: 'app-data-item-template',
  template: `
    <ng-content />
    @if (flippable()) {
      <ul class="flippable">
        <li [class.active]="!isFlip()"></li>
        <li [class.active]="isFlip()"></li>
      </ul>
    }
  `,
  styleUrl: './data-item-template.scss',
  host: {
    '[class]': 'size()',
    '[class.flippable]': 'flippable()',
    '[class.isFlip]': 'isFlip()',
  },
  hostDirectives: [DisplayAnimations],
})
export class DataItemTemplate {
  protected webSocketService: WebSocketService = inject(WebSocketService);
  protected broadcastData: Signal<WSBroadcastDataMessage['data']> = computed<
    WSBroadcastDataMessage['data']
  >(() => this.webSocketService.broadcastData()?.data ?? DEFAULT_DATA);
  dataBlock: InputSignal<BlockTemplateType> = input.required();
  flippable: Signal<boolean> = computed(() => this.dataBlock().flippable || false);
  isFlip: Signal<boolean> = computed(() => this.dataBlock().isFlip || false);
  size: Signal<UISizeType> = computed(() => this.dataBlock().size || 'small');
  iconSize: Signal<number> = computed<number>(() => {
    switch (this.size()) {
      case 'large':
        return 4.5;
      default:
        return 3.5;
    }
  });
}
